// The result card a `case-study` command prints after its trace.
import React from 'react';

const CaseStudyCard = ({ study }) => {
  const { before, after } = study.metrics;

  return (
    <div className="case-card">
      <div className="case-head">
        <div className="case-head-text">
          <span className="case-meta">CASE STUDY · {study.meta}</span>
          <span className="case-title">{study.title}</span>
        </div>
        <span className="case-subtitle">{study.subtitle}</span>
      </div>

      <div className="case-metrics">
        <div className="case-metric">
          <span className="metric-label">{before.label}</span>
          <span className="metric-value metric-value-before">{before.value}</span>
          <span className="metric-unit">{before.unit}</span>
          <div className="metric-bar">
            <div className="metric-fill metric-fill-before" style={{ width: `${before.fill}%` }} />
          </div>
        </div>
        <div className="case-metric case-metric-after">
          <span className="metric-label metric-label-after">{after.label}</span>
          <span className="metric-value">{after.value}</span>
          <span className="metric-unit">{after.unit}</span>
          <div className="metric-bar">
            <div className="metric-fill metric-fill-after" style={{ width: `${after.fill}%` }} />
          </div>
        </div>
      </div>

      <div className="case-points">
        {study.points.map((point) => (
          <div key={point} className="case-point">
            <span className="case-bullet">›</span>
            <span>{point}</span>
          </div>
        ))}
      </div>

      <div className="case-tags">
        {study.tags.map((tag) => (
          <span key={tag} className="case-tag">{tag}</span>
        ))}
      </div>
    </div>
  );
};

export default CaseStudyCard;
